import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SimpleBar from "simplebar"

gsap.registerPlugin(ScrollTrigger);

const topPage = () => {

	const scrIcn = document.querySelector('.colmun-list-wrap-outer .scr-icn')
	const scrWrap = document.querySelector('.colmun-list-wrap');
	const list = document.querySelector('.colmun-list')
	const simpleBar = new SimpleBar(scrWrap);

	simpleBar.getScrollElement().addEventListener('scroll', () => {
		scrIcn.classList.add('is-hide')
	});

	if(list.clientWidth <= scrWrap.clientWidth){
		scrIcn.classList.add('is-hide');
	}



}

export default topPage